import { ImageType } from './files';
import { Address } from './address';

export interface StoreRequest {
  id: number;
  request_date: string;
  archived: boolean;
  status: number;
  status_name: string;
  request_type: number;
  request_type_name: string;
  response: Response;
  store_id: number;
  store_name_en: string;
  store_name_ar: string;
  seller_id: number;
}

interface Response {
  id: number;
  request_id: number;
  manager_id: number;
  response_date: string;
  msg: string;
  read: boolean;
}

export interface StoreBrief {
  id: string;
  name_en: string;
  name_ar: string;
  bio: string;
  slogan: string;
  logo_image_alt?: string;
  logo_image_public_url?: string;
  cover_image_public_url?: string;
  business_phone: string;
  business_email: string;
  main_category_en: string;
  main_category_ar: string;
  region: string;
  member_since: string;
  listed: boolean;
  _version_: number;
}

export interface StoreImageName {
  id: string;
  name_en: string;
  name_ar: string;
  logo_img: ImageType;
}

export interface StoreDetails {
  type: string;
  id: number;
  name_en: string;
  name_ar: string;
  slogan: string;
  region: number;
  bio: string;
  member_since: string;
  address: Address[];
  is_approved: boolean;
  free_shipping_threshold: number;
  order_preparation_hours: number;
  accepts_mobile_payments: boolean;
  accepts_credit_card_payments: boolean;
  accepts_cash_payments: boolean;
  accepts_cheques_payments: boolean;
  working_time_sat_start: string;
  working_time_sun_start: string;
  working_time_mon_start: string;
  working_time_tue_start: string;
  working_time_wed_start: string;
  working_time_thu_start: string;
  working_time_fri_start: string;
  working_time_sat_end: string;
  working_time_sun_end: string;
  working_time_mon_end: string;
  working_time_tue_end: string;
  working_time_wed_end: string;
  working_time_thu_end: string;
  working_time_fri_end: string;
  tax_id: string;
  is_home_business: boolean;
  owner_name: string;
  owning_seller_name: string;
  owner_id: number;
  business_owner_full_name: string;
  business_phone: string;
  business_email: string;
  business_website_url?: string;
  business_social_media_url?: string;
  main_category_id: number;
  main_category_name_en: string;
  main_category_name_ar: string;
  add_store_request: StoreRequest;
  bank_number: number;
  bank_branch_number: number;
  bank_account_number: number;
  tax_type: number;
  deduction_at_source?: number;
  logo_img?: ImageType;
  business_owner_image?: ImageType;
  cover_image?: ImageType;
  business_bank_statement?: ImageType;
  business_tax_certificate?: ImageType;
  business_das_certificate?: ImageType;
  current_user_access_level?: number;
}

export enum BusinessTaxType {
  exempt = 'exempt',
  licensed_il = 'licensed_il',
}

export const businessTaxTypeMap: { [key: string]: string } = {
  1: 'exempt',
  2: 'licensed_il',
};
